import React from 'react'
import {
  LuArrowLeftRight,
  LuLayoutGrid,
  LuNetwork,
  LuSettings,
  LuUsers,
} from 'react-icons/lu'

import { NETWORK_DASHBOARD_SIDEBAR_LINKS } from '@/lib/constants'
import { ROUTES } from '@/lib/routes'
import { SidebarLink } from '@/types/misc'

// Overview, Dashboard and Referral register are built so far; the other
// sections show as "coming soon" the way the group sidebar shows Team.
export function useNetworkDashboardSidebarLinks() {
  const overviewLink: SidebarLink = {
    title: NETWORK_DASHBOARD_SIDEBAR_LINKS.overview,
    href: ROUTES.networkOverview(),
    icon: <LuNetwork size={18} />,
  }

  const dashboardLink: SidebarLink = {
    title: NETWORK_DASHBOARD_SIDEBAR_LINKS.dashboard,
    href: ROUTES.networkDashboard(),
    icon: <LuLayoutGrid size={18} />,
  }

  const referralRegisterLink: SidebarLink = {
    title: NETWORK_DASHBOARD_SIDEBAR_LINKS.referralRegister,
    href: ROUTES.networkReferralRegister(),
    icon: <LuArrowLeftRight className="size-4" />,
  }

  const usersLink: SidebarLink = {
    title: NETWORK_DASHBOARD_SIDEBAR_LINKS.users,
    href: '#',
    icon: <LuUsers size={18} />,
    comingSoonText: 'Network user management is coming soon',
    style: { opacity: 0.4 },
  }

  const settingsLink: SidebarLink = {
    title: NETWORK_DASHBOARD_SIDEBAR_LINKS.settings,
    href: '#',
    icon: <LuSettings size={18} />,
    comingSoonText: 'Network settings are coming soon',
    style: { opacity: 0.4 },
  }

  return [
    overviewLink,
    dashboardLink,
    referralRegisterLink,
    usersLink,
    settingsLink,
  ]
}
